import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Cliente, TipoCliente, Tarjeta, Cookies } from 'app/models/data.model';
import { UtilityProvider } from 'app/providers/utility/utility';
import { DataManagement } from 'app/services/dataManagement';
import { Router } from '@angular/router';
import { ClienteForm } from 'app/models/form.model';
import { CryptProvider } from 'app/providers/crypt/crypt';
import { fuseAnimations } from '@fuse/animations';
import { RestWS } from 'app/services/restService';
import { GlobalService } from 'app/services/globalService';
import { FuseConfigService } from '@fuse/services/config.service';




import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';


@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ProfileComponent implements OnInit {
getCliente():any {
   return this.globalService.clienteAivoz;
}

    // CAMARA 

    muestraCamara: boolean = false;
    haveFace: boolean = false;
    faceCliente: any = [];
    textoFace: string = 'Mire a la camara por favor...'

    constraints = {
        video: {
            facingMode: 'user',
            width: { ideal: 300 },
            height: { ideal: 300 }
        },
       
      };
    
      videoWidth = 0;
      videoHeight = 0;
      stream: any;
    
      elementType = 'url';  
      public imagePath;  
      value : any;  
      @ViewChild('result') resultElement: ElementRef;  
    
      @ViewChild('video') videoElement: ElementRef;
    
      @ViewChild('canvas') canvas: ElementRef;
      @ViewChild('foto') canvasFoto: ElementRef;

    //


    cliente: any;
    clave: string;
    registerForm: FormGroup;
    registerFormTarjeta: FormGroup;
    registerFormPassword: FormGroup;
    registerFormPlan: FormGroup;
    registerFormCliente: FormGroup;
    clienteEditar: string;


    plans = [
        { nombre: "Gratuito1" },
        { nombre: "Gratuito5" },
        { nombre: "Gratuito50" }
    ]

    selectedPlan = { nombre: "Ningún Plan Seleccionado", stripeId: "" };

    cookies: Cookies;

    constructor(
        private api: RestWS,
        private globalService: GlobalService,
        private translationLoader: FuseTranslationLoaderService,
        private _formBuilder: FormBuilder,
        private _fuseConfigService: FuseConfigService,
        private utils: UtilityProvider,
        private router: Router,
        private crypto: CryptProvider,
        private renderer: Renderer2

    ) {
        this.translationLoader.loadTranslations(english, spanish);
    }

    ngOnInit() {
        this.cookies = this.globalService.cookies;
        this.cliente = this.globalService.clienteAivoz;
        console.log('Tarjeta: ', this.cliente.tarjetaPago);
        

        this.registerForm = this._formBuilder.group({
            razonSocial: ['', Validators.required],
            cif: ['', Validators.required],
            telefono1: [''],
            telefono2: [''],
            nombreComercial: [''],
            direccionFacturacion: [''],
            web: [''],
            codigoPromocional: [''],
            numeroTarjeta: [''],
            mesTarjeta: [''],
            anyoTarjeta: [''],
            cvvTarjeta: [''],
            contactoNombre: [''],
            contactoEmail: ['']
        });

        this.registerFormTarjeta = this._formBuilder.group({

            numeroTarjeta: ['', [Validators.required, cardNumberValidator]],
            mesTarjeta: ['', [Validators.required, mesValidator]],
            anyoTarjeta: ['', [Validators.required, anyoValidator]],
            cvvTarjeta: ['']

        });

        this.registerFormPassword = this._formBuilder.group({

            oldclave: ['', Validators.required],
            clave: ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPasswordValidator]],

        });

        this.registerFormPlan = this._formBuilder.group({
            plan: ['']
        });

        this.registerFormCliente = this._formBuilder.group({
            emailCliente: [''],
            planCliente: [''],
            passCliente: [''],
            subscripcionCliente: ['']
        });
    }

    irSuscripcion() {
        //console.log('asdf')
        window.location.replace('/#/pages/pricing/style-1');
    }

// CAMARA 

facelogin() {
    this.startCamera();
    this.faceCliente = [];
    this.muestraCamara = true;
    this.haveFace = false;
    
}

cancelfacelogin() {
    this.stopvideo();
    this.muestraCamara = false;
    //this.haveFace = false;
}

stopvideo() {
    this.pauseTimer();
    this.stream.getTracks().forEach(function(track) {
      track.stop();
    });
    this.muestraCamara = false;
  }

  dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }

  async capture() {
    this.pauseTimer()
    let canvascara = document.createElement("canvas");
    canvascara.height = 300;
    canvascara.width = 300;
    canvascara.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
    this.value = canvascara.toDataURL("image/png")//.replace("image/png", "image/octet-stream");
    setTimeout( async t => {
            var file = await this.dataURLtoFile(this.value, 'uno.png')
            this.api.isface(file).then( resp => {
                console.log(resp)
                if (resp.isFace) {
                    this.textoFace = "Por favor, sonria...";
                    this.faceCliente.push(file);
                    if (this.faceCliente.length === 3 ) {
                        this.haveFace = true;
                        this.cancelfacelogin();
                    } else {
                        this.startTimer();
                    }
                           
                } else {
                    this.startTimer()
                }
            })
      },500);
  

}

startCamera() {
  
    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { 
        navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
    } else {
        alert('Sorry, camera not available.');
        this.startTimer();
    }
  }
  
  handleError(error) {
  console.log('Error: ', error);
  //this.loading = false;
  }
  
  async attachVideo(stream) {
  
    console.log('atach 1')
    this.stream = stream;
    this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
    await this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
        this.videoHeight = this.videoElement.nativeElement.videoHeight;
        this.videoWidth = this.videoElement.nativeElement.videoWidth;
        this.capture();
    });
  
  
   //this.startTimer();
   console.log('atach 2')
   
   
  }
  
  timeLeft: number = 1;
  interval;
  
  startTimer() {
      this.interval = setInterval(() => {
        if(this.timeLeft > 1) {
          this.timeLeft--;
          
        } else {
          this.timeLeft = 1;
          console.log('timer')
          //this.textoFace = 'Capturando Imagen'
          this.capture();
        }
      }, 1000)
    }
  
    pauseTimer() {
      clearInterval(this.interval);
    }
  

//



    updateClient() {

        //console.log(this.cliente);
        this.api.updateEmpresa(this.globalService.clienteAivoz).then(result => {

            if (result.status === 'ok') {
                this.globalService.clienteAivoz = result.message;
                this.utils.openDialog(this.utils.SUCCESS, 'PROFILE.UPDATEOK', false, false, null, { traducir: true });
                //this.updateClienteFace(this.cliente);
            } else {
                this.utils.openDialog(this.utils.ERROR, 'PFOFILE.UPDATEBAD', false, false, null, { traducir: true });
            }
        })
    } 

    updateFace() {
        let error = false;
        this.api.deletefaces(this.cliente._id).then( rem => {
            for (let i = 0; i < 3; i ++) {
                this.api.newface(this.faceCliente[i], this.cliente._id ).then( resp => {
                  if (resp.status === 'bad') {
                      error = true;
                      i = 3;
                  }
                }).catch(err => {
                    error = true;
                })
            }
            if (!error) {
                this.utils.openDialog(this.utils.SUCCESS, "Rostro actualizado con éxito", false, false, null, "Rostro Actualzado con éxito");
                this.haveFace = false;
            } else {
                this.utils.openDialog(this.utils.ERROR, "Error al actualizar Rostro. Intentelo de Nuevo", false, false, null, "Rostro Actualzado con éxito");
                this.haveFace = false;
            }
        }).catch( err => {
            error = true;
            this.utils.openDialog(this.utils.ERROR, "Error al actualizar Rostro. Intentelo de Nuevo", false, false, null, "Rostro Actualzado con éxito");
            this.haveFace = false;
        })
       
       
       


    }
        

    async verCliente() {
        let cliente = await this.api.getClientByEmail(this.registerFormCliente.get('emailCliente').value);
        if (cliente.status === 'ok') {
            let data = {
                subscripcion: 'Subscripcion: ' + cliente.message[0].stripe.subscripcion,
                plan: 'Plan: ' + cliente.message[0].stripe.plan,
                cif: cliente.message[0].cif,
                direccion: cliente.message[0].direccionFacturacion,
                telefono1: cliente.message[0].telefono1,
                telefono2: cliente.message[0].telefono2,
                contacto: cliente.message[0].contacto.email
            }

            this.utils.openDialog(this.utils.SUCCESS, cliente.message[0].razonSocial, false, false, null, data);
        } else {
            this.utils.openDialog(this.utils.ERROR, 'No se han podido leer los datos.', false, false)
        }

    }

    async accederPanelCliente() {
        let cliente = await this.api.getClientByEmail(this.registerFormCliente.get('emailCliente').value);
        //console.log(cliente);
        if (cliente.status === 'ok') {
            if (cliente.message.length > 0) {

                this.cookies.cliente = cliente.message[0]._id;
                this.globalService.iniciarSesion(cliente.message[0], this.cookies);
                await this.globalService.leerCookies(true);
                this.router.navigateByUrl("/apps/dashboards/analytics");
            } else {
                this.utils.openDialog(this.utils.ERROR, 'El cliente no existe.', false, false)
            }
        } else {
            this.utils.openDialog(this.utils.ERROR, 'No se han podido leer los datos.', false, false)
        }

    }

    borrarCliente() {
        this.utils.openDialog(this.utils.WARNING, '¿ Desea BORRAR el Cliente ?', true, true)
            .then(resp => {
                if (resp === true) {
                    this.api.borrarCliente(this.registerFormCliente.get('emailCliente').value).then(result => {
                        if (result.status === 'ok') {
                            this.utils.openDialog(this.utils.SUCCESS, 'Cliente eliminado con éxito', false, false)
                        } else {
                            this.utils.openDialog(this.utils.ERROR, 'Error al eliminar Cliente', false, false)

                        }
                    })
                }
            })
    }

    updatePassCliente() {
        this.utils.openDialog(this.utils.WARNING, '¿ Desea Actualizar Contraseña Cliente ?', true, true)
            .then(async resp => {
                if (resp === true) {
                    let cliente = await this.api.getClientByEmail(this.registerFormCliente.get('emailCliente').value);
                    if (cliente.status === 'ok') {
                        cliente.message[0].clave = this.registerFormCliente.get('passCliente').value;
                        this.api.modificarCliente(cliente.message[0]).then(result => {
                            if (result.status === 'ok') {
                                this.utils.openDialog(this.utils.SUCCESS, 'PROFILE.UPDATEOK', false, false, null, { traducir: true })
                            } else {
                                this.utils.openDialog(this.utils.ERROR, 'PROFILE.UPDATEBAD', false, false, null, { traducir: true })
                            }
                        })
                    }
                }
            })
    }

    updatePlanCliente() {
        this.utils.openDialog(this.utils.WARNING, '¿ Desea Actualizar el Cliente ?', true, true)
            .then(async resp => {
                if (resp === true) {
                    let nuevoplan = this.registerFormCliente.get('planCliente').value;
                    let cliente = await this.api.getClientByEmail(this.registerFormCliente.get('emailCliente').value);
                    if (cliente.status === 'ok') {
                        cliente.message[0].stripe.plan = nuevoplan;
                        cliente.message[0].stripe.subscripcion = "";
                        this.api.editarClienteStripe(cliente.message[0], '').then(result => {
                            if (result.status === 'ok') {
                                this.utils.openDialog(this.utils.SUCCESS, 'PROFILE.UPDATEOK', false, false, null, { traducir: true })
                            } else {
                                this.utils.openDialog(this.utils.ERROR, 'PROFILE.UPDATEBAD', false, false, null, { traducir: true })

                            }
                        })
                    } else {
                        this.utils.openDialog(this.utils.ERROR, 'Error al encontrar el cliente. ¿ Email Correcto ?', false, false)

                    }

                }
            })
    }

    updateSubscripcionCliente() {
        this.utils.openDialog(this.utils.WARNING, '¿ Desea Actualizar el Cliente ?', true, true)
            .then(async resp => {
                if (resp === true) {
                    let nuevaSubscripcion = this.registerFormCliente.get('subscripcionCliente').value;
                    let cliente = await this.api.getClientByEmail(this.registerFormCliente.get('emailCliente').value);
                    if (cliente.status === 'ok') {
                        cliente.message[0].stripe.subscripcion = nuevaSubscripcion;
                        this.api.editarClienteStripe(cliente.message[0], '').then(result => {
                            if (result.status === 'ok') {
                                this.utils.openDialog(this.utils.SUCCESS, 'PROFILE.UPDATEOK', false, false, null, { traducir: true })
                            } else {
                                this.utils.openDialog(this.utils.ERROR, 'PROFILE.UPDATEBAD', false, false, null, { traducir: true })

                            }
                        })
                    } else {
                        this.utils.openDialog(this.utils.ERROR, 'Error al encontrar el cliente. ¿ Email Correcto ?', false, false)

                    }

                }
            })
    }



    updatePassword() {
        let claveold: any;
        claveold = this.api.decryptdata('becheckin', this.cliente.clave);
        console.log('Clave old: ', claveold.message)
        this.api.encryptdata('becheckin', this.registerFormPassword.get('oldclave').value).then(data => {
            if (data.status === 'ok') {
                if (data.message === this.cliente.clave) {
                    //let nuevaClave = this.api.encryptdata('becheckin', this.registerFormPassword.get('clave').value);
                    this.cliente.clave = this.registerFormPassword.get('clave').value;
                    this.updateClient();
                } else {
                    this.utils.openDialog(this.utils.ERROR, 'PROFILE.UPDATEPASSWORDBAD', false, false, null, { traducir: true })
                }
            } else {
                this.utils.openDialog(this.utils.ERROR, 'PROFILE.UPDATEPASSWORDBAD', false, false, null, { traducir: true })
            }
        })




    }

    updateTarjeta() {

        //console.log(this.cliente.tarjetaPago)

        if ((this.registerFormTarjeta.get('numeroTarjeta').value !== this.cliente.tarjetaPago.numero) ||
            (this.registerFormTarjeta.get('mesTarjeta').value !== this.cliente.tarjetaPago.mes) ||
            (this.registerFormTarjeta.get('anyoTarjeta').value !== this.cliente.tarjetaPago.anyo) ||
            (this.registerFormTarjeta.get('cvvTarjeta').value !== this.cliente.tarjetaPago.cvv)) {
            this.utils.openDialog(this.utils.WARNING, 'PROFILE.PAYMENTNEW', true, true, null, { traducir: true })
                .then(resp => {
                    if (resp === true) {
                        this.aceptar_metodopago();
                    }
                })

        } else {
            this.utils.openDialog(this.utils.WARNING, 'PROFILE.PAYMENTNODATA', false, false, null, { traducir: true })

        }
    }


    aceptar_metodopago() {
        let card = {
            number: this.registerFormTarjeta.get('numeroTarjeta').value,
            month: this.registerFormTarjeta.get('mesTarjeta').value,
            year: this.registerFormTarjeta.get('anyoTarjeta').value,
            cvc: this.registerFormTarjeta.get('cvvTarjeta').value
        }



        let cardCliente = {
            numero: card.number,
            mes: card.month,
            anyo: card.year,
            cvv: card.cvc
        }
        this.api.createPayment(card, this.globalService.clienteAivoz.email).then(payment => {
            if (payment.status === 'ok') {
                if (this.cliente.stripe.customer === '') {
                    this.api.createCustomer(payment.message.id, this.cliente.email).then(customer => {
                        if (customer.status === 'ok') {
                            this.cliente.stripe.customer = customer.message.id;
                            this.cliente.tarjetaPago = cardCliente;
                            this.cliente.stripe.card = payment.message.id;
                            this.editarClienteStripe();
                        } else {
                            this.cliente.tarjetaPago = cardCliente;
                            this.cliente.stripe.card = payment.message.id;
                            this.editarClienteStripe();
                        }
                    })
                } else {
                    this.cliente.tarjetaPago = cardCliente;
                    this.cliente.stripe.card = payment.message.id;
                    this.editarClienteStripe();
                }

            } else {
                this.utils.openDialog(this.utils.ERROR, 'Error al actualizar la tarjeta. Compruebe los datos.', false, false)
            }
        })
    }

    editarClienteStripe() {
        this.api.editarClienteStripe(this.cliente, 'tarjeta').then(cliente => {
            if (cliente.status === 'ok') {
                //console.log(cliente)
                this.utils.openDialog(this.utils.SUCCESS, 'Actualizado el método de Pago con éxito.', false, false)
            } else {
                this.utils.openDialog(this.utils.ERROR, 'Error al actualizar el método de Pago. Compruebe los datos.', false, false)
            }
        })
    }

    comprobar_tarjeta() {
        if (
            (this.registerFormTarjeta.get('numeroTarjeta').value !== '') &&
            (this.cliente.tarjetaPago.anyo !== '') &&
            (this.cliente.tarjetaPago.cvv !== '') &&
            (this.validarTarjeta(this.registerFormTarjeta.get('numeroTarjeta').value))) {
            return true && !this.registerFormTarjeta.invalid
        } else {
            return false;
        }
    }

    validarTarjeta(numero_tarjeta) {
        let cadena = numero_tarjeta.toString();
        cadena = cadena.replace(/ /g, "")
        let longitud = cadena.length;
        let cifra = null;
        let cifra_cad = null;
        let suma = 0;
        for (let i = 0; i < longitud; i += 2) {
            cifra = parseInt(cadena.charAt(i)) * 2;
            if (cifra > 9) {
                cifra_cad = cifra.toString();
                cifra = parseInt(cifra_cad.charAt(0)) +
                    parseInt(cifra_cad.charAt(1));
            }
            suma += cifra;
        }
        for (let i = 1; i < longitud; i += 2) {
            suma += parseInt(cadena.charAt(i));
        }

        // let numDigitos = longitud == 0 || longitud == 16;
        let numDigitos = longitud === 16;

        if (((suma % 10) == 0 && numDigitos)) {
            return true;
        } else {
            return false;
        }
    }

    seleccionadoPlan() {

        this.utils.openDialog(this.utils.SUCCESS, 'Ha seleccionado plan: ' + this.selectedPlan.nombre, false, false)
    }


}
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const password = control.parent.get('clave');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if (!password || !passwordConfirm) {
        return null;
    }

    if (passwordConfirm.value === '') {
        return null;
    }

    if (password.value === passwordConfirm.value) {
        return null;
    }

    return { passwordsNotMatching: true };
};

export const cardNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const numero_tarjeta = control.parent.get('numeroTarjeta').value;
    //console.log(numero_tarjeta);
    let cadena = numero_tarjeta.toString();
    cadena = cadena.replace(/ /g, "")
    let longitud = cadena.length;
    let cifra = null;
    let cifra_cad = null;
    let suma = 0;
    for (let i = 0; i < longitud; i += 2) {
        cifra = parseInt(cadena.charAt(i)) * 2;
        if (cifra > 9) {
            cifra_cad = cifra.toString();
            cifra = parseInt(cifra_cad.charAt(0)) +
                parseInt(cifra_cad.charAt(1));
        }
        //console.log(cifra);
        suma += cifra;
    }
    for (let i = 1; i < longitud; i += 2) {
        suma += parseInt(cadena.charAt(i));
    }

    //let numDigitos = longitud == 0 || longitud == 16;
    let numDigitos = longitud === 16;
    //console.log("suma", suma);
    //console.log("numDigitos", numDigitos);
    //console.log("longitud", longitud);
    if (((suma % 10) == 0 && numDigitos)) {
        return null;
    } else {
        return { cardNumberNotValid: true };
    }
};

export const mesValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const mes_tarjeta = control.parent.get('mesTarjeta').value;

    if (mes_tarjeta > 0 && mes_tarjeta < 13) {
        return null;
    } else {
        return { cardMonthNotValid: true }
    }

}

export const anyoValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const anyo_tarjeta = control.parent.get('anyoTarjeta').value;

    if (anyo_tarjeta >= 20 && anyo_tarjeta < 99) {
        return null;
    } else {
        return { cardYearhNotValid: true }
    }

}

export const cvcValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const anyo_tarjeta = control.parent.get('cvc').value;


    return null;


}